import { createRouter, createWebHistory } from 'vue-router'

import { routes } from './routes'

import { authGuard, rolesGuard } from './guards'

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

router.beforeEach(authGuard)
router.beforeEach(rolesGuard)
